import Api from "../api";
const { axios: api } = Api;
const queryString = require("query-string");

const PREFIX = "admin";

export const createAdmin = async (payload) => {
  const data = await api.post(`/${PREFIX}`, payload);
  return { data: data.data };
};

export const updateAdmin = async (payload) => {
  const data = await api.patch(`/${PREFIX}/${payload._id}`, payload);
  return { data: data.data };
};
